import { memo } from 'react';
import { Flex } from '../Flex/Flex';
import { Checkbox } from './Checkbox';
import { HighlightText } from './HighlightText';
import { StyledMenuOptionContentWrapper, StyledMenuOptionIndicator } from './Select.styles';
import { Text } from '../../components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MemoizedOptionContent = /*#__PURE__*/memo(({
  multi,
  isSelected,
  disabled,
  indicator,
  text,
  supportText,
  inputValue,
  isSubheading
}) => {
  const color = disabled ? 'text-primary-disabled' : 'text-core-default';
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "300",
    children: [multi && !isSubheading && /*#__PURE__*/_jsx(Checkbox, {
      checked: isSelected,
      disabled: disabled
    }), /*#__PURE__*/_jsxs(StyledMenuOptionContentWrapper, {
      $optionTextColor: color,
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [indicator && /*#__PURE__*/_jsx(StyledMenuOptionIndicator, {
          children: indicator
        }), isSubheading ? /*#__PURE__*/_jsx(Text, {
          truncate: true,
          color: color,
          typography: "heading-50",
          children: text
        }) : /*#__PURE__*/_jsx(HighlightText, {
          text: text,
          highlight: inputValue,
          optionTextColor: color
        })]
      }), supportText && /*#__PURE__*/_jsx(HighlightText, {
        isSupportText: true,
        text: supportText,
        highlight: inputValue,
        optionTextColor: color
      })]
    })]
  });
});
export const OptionContent = MemoizedOptionContent;